import App from '@/models/App'

export default class OrderingOrdererOrderDocument extends App {
    static get entity() {
        return 'OrderingOrdererOrderDocuments'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            orderingAccountId: this.attr(''),
            name: this.attr(''),
            origin: this.attr(''),
            ext: this.attr(''),
            size: this.attr(''),
            type: this.attr(''), // Added type field
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            presignedUrl: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, orderingOrderId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/documents`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            find(orderingShipId, orderingOrderId, orderingOrderDocumentId) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/documents/${orderingOrderDocumentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, orderingOrderId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/documents`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingOrderDocumentId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/documents/${orderingOrderDocumentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingOrderDocumentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
